import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-criminal-proceed-view',
  templateUrl: './criminal-proceed-view.component.html',
  styleUrls: ['./criminal-proceed-view.component.css']
})
export class CriminalProceedViewComponent implements OnInit {
  title="Form1/Form 2: Form for verification of character and antecedents of All Employees";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/criminal-proceedings/criminal-proceed-view/criminal-proceed-view.component.ts